module.exports = __webpack_public_path__ + "img/烈风.55a1b4fa.png";